import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="role-selection-segmented"
export default class extends Controller {
  static targets = [
    "button",
    "content",
    "defaultContent",
    "scoutRadio",
    "talentRadio",
    "submitButton",
    "errorMessage",
  ];

  connect() {
    // Initialize with talent selected by default
    this.updateButtonStates("talent");
    this.updateContent("talent");
    this.updateHiddenRadio("talent");
    this.updateSubmitButton();
  }

  selectRole(event) {
    const selectedRole = event.currentTarget.dataset.role;
    this.updateButtonStates(selectedRole);
    this.updateContent(selectedRole);
    this.updateHiddenRadio(selectedRole);
    this.updateSubmitButton();
    this.hideErrorMessage();
  }

  updateButtonStates(selectedRole) {
    this.buttonTargets.forEach((button) => {
      const role = button.dataset.role;

      if (role === selectedRole) {
        // Selected state - dark background with white text
        button.classList.remove(
          "bg-transparent",
          "text-stone-600",
          "hover:text-stone-800"
        );
        button.classList.add("bg-stone-900", "text-white");
      } else {
        // Unselected state - transparent background with gray text
        button.classList.remove("bg-stone-900", "text-white");
        button.classList.add(
          "bg-transparent",
          "text-stone-600",
          "hover:text-stone-800"
        );
      }
    });
  }

  updateContent(selectedRole) {
    // Hide default content
    if (this.hasDefaultContentTarget) {
      this.defaultContentTarget.classList.add("hidden");
    }

    // Show/hide content based on selection
    this.contentTargets.forEach((content) => {
      const role = content.dataset.role;

      if (role === selectedRole) {
        content.classList.remove("hidden");
      } else {
        content.classList.add("hidden");
      }
    });
  }

  updateHiddenRadio(selectedRole) {
    // Update the hidden radio buttons for form submission
    if (selectedRole === "scout") {
      this.scoutRadioTarget.checked = true;
      this.talentRadioTarget.checked = false;
    } else if (selectedRole === "talent") {
      this.talentRadioTarget.checked = true;
      this.scoutRadioTarget.checked = false;
    }
  }

  updateSubmitButton() {
    const hasSelection =
      this.scoutRadioTarget.checked || this.talentRadioTarget.checked;

    if (hasSelection) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.classList.remove(
        "opacity-50",
        "cursor-not-allowed"
      );
    } else {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed");
    }
  }

  hideErrorMessage() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.add("hidden");
    }
  }

  showErrorMessage() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.classList.remove("hidden");
    }
  }
}
